import script from "./SelectTransactionType.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectTransactionType.vue?vue&type=script&setup=true&lang=js"

import "./SelectTransactionType.vue?vue&type=style&index=0&id=a428c01c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a428c01c"]])

export default __exports__